import { specialTileDefinition } from '../../specialTiles/challengeSpecialTileParts'
import {
  createBoardDistributionStep,
  createBonusStep,
  createGridSizeStep,
  createIntervalTimeStep,
  createMinWordLengthStep,
  createSpecialTileStep,
  createVowelRatioBandStep,
} from '../steps'
import type { BoggleChallengeConfigurationDefinition } from '../types'

export const contagion = {
  enabled: false,
  gameModeIds: ['race'],
  id: 'contagion',
  weight: 10,
  metadata: {
    description: 'Contagion',
    name: 'Contagion',
    shortLabel: 'Contagion',
  },
  pathMode: 'free',
  resolveScoreThresholds: input => {
    let targetScore = 30

    // Grid size
    if (input.settings.gridSize === '3x3') {
      targetScore -= 2
    }
    if (input.settings.gridSize === '4x4') {
      targetScore -= 5
    }

    // Interval time
    if (input.settings.intervalTimeSeconds === 60) {
      targetScore *= 0.7
    }
    if (input.settings.intervalTimeSeconds === 120) {
      targetScore *= 1.3
    }

    return {
      aceScore: Math.round((targetScore * 5) / 3),
      targetScore: Math.round(targetScore),
    }
  },
  steps: [
    createGridSizeStep(() => [
      { value: '3x3', weight: 1 },
      { value: '4x3', weight: 3 },
      { value: '4x4', weight: 1 },
    ]),
    createIntervalTimeStep(({ rolledState }) => [
      { value: 60, weight: 1 },
      { value: 90, weight: 4 },
      { value: 120, weight: 2 },
    ]),
    createSpecialTileStep(({ rolledState }) => ({
      options: [
        {
          value: specialTileDefinition({
            interactionId: 'contagion',
            kind: 'purple',
            supplyId: 'reset-empty-one',
          }),
          weight: 1,
        },
      ],
    })),
  ],
} as const satisfies BoggleChallengeConfigurationDefinition<'contagion'>
